import React from 'react';
import { ChevronRight, Home, ArrowLeft } from 'lucide-react';

const Breadcrumb = ({ 
  items = [], 
  onNavigate, 
  showBackButton = true, 
  onBack,
  className = "" 
}) => {
  return (
    <nav className={`flex items-center space-x-2 text-sm ${className}`}>
      {/* Back Button */}
      {showBackButton && onBack && (
        <button
          onClick={onBack}
          className="flex items-center px-3 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-md transition-colors"
          title="返回上一頁"
        >
          <ArrowLeft className="w-4 h-4 mr-1" />
          <span className="hidden sm:inline">返回</span>
        </button>
      )}
      
      {/* Breadcrumb Items */}
      <ol className="flex items-center space-x-2">
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <ChevronRight className="w-4 h-4 text-gray-400 mx-2" />
            )}
            
            {item.href && index < items.length - 1 ? (
              <button
                onClick={() => onNavigate && onNavigate(item.href, item)}
                className="flex items-center text-gray-600 hover:text-gray-800 hover:underline transition-colors"
              >
                {item.icon && <item.icon className="w-4 h-4 mr-1" />}
                <span>{item.label}</span>
              </button>
            ) : (
              <span className={`flex items-center ${
                index === items.length - 1 
                  ? 'text-gray-900 font-medium' 
                  : 'text-gray-600'
              }`}>
                {item.icon && <item.icon className="w-4 h-4 mr-1" />}
                <span>{item.label}</span>
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

// Quick Navigation Menu Component
const QuickNavMenu = ({ 
  isOpen, 
  onClose, 
  onNavigate, 
  currentContext = null,
  className = "" 
}) => {
  const quickNavItems = [
    { id: 'dashboard', label: '主控台', icon: Home, description: '系統總覽' },
    { id: 'workflows', label: '業務流程', icon: 'Activity', description: '專業工作流程' },
    { id: 'mrp', label: '物料需求計劃', icon: 'Layers', description: 'MRP規劃' },
    { id: 'inventory', label: '庫存管理', icon: 'Boxes', description: '庫存控制' },
    { id: 'production', label: '生產管理', icon: 'Factory', description: '生產控制' },
    { id: 'purchase-orders', label: '採購訂單', icon: 'ShoppingCart', description: '採購管理' },
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-hidden">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-25"
        onClick={onClose}
      />
      
      {/* Menu Panel */}
      <div className="absolute right-0 top-0 h-full w-80 bg-white shadow-xl">
        <div className="p-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-800">快速導航</h3>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-md"
            >
              <ChevronRight className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        </div>
        
        <div className="p-4 space-y-2">
          {quickNavItems.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                onNavigate && onNavigate(item.id, item);
                onClose();
              }}
              className={`w-full flex items-center p-3 rounded-lg text-left transition-colors ${
                currentContext === item.id
                  ? 'bg-blue-50 text-blue-700 border border-blue-200'
                  : 'hover:bg-gray-50 text-gray-700'
              }`}
            >
              <div className="flex-shrink-0 w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center mr-3">
                {item.icon === 'Activity' && <span className="text-gray-600">📊</span>}
                {item.icon === 'Layers' && <span className="text-gray-600">📋</span>}
                {item.icon === 'Boxes' && <span className="text-gray-600">📦</span>}
                {item.icon === 'Factory' && <span className="text-gray-600">🏭</span>}
                {item.icon === 'ShoppingCart' && <span className="text-gray-600">🛒</span>}
                {item.icon === Home && <Home className="w-5 h-5 text-gray-600" />}
              </div>
              <div className="flex-1">
                <div className="font-medium">{item.label}</div>
                <div className="text-sm text-gray-500">{item.description}</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export { Breadcrumb, QuickNavMenu };
export default Breadcrumb; 